var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sensorId || _vm.createNewSensor)?_c('SensorDetails',{attrs:{"sensorId":_vm.sensorId,"createNew":_vm.createNewSensor}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }